import { NOTIFICATION_TYPE } from "@/helper/enums";
import { getChapter } from "@/services/axios/protectedApi";
import type { NextRouter } from "next/router";

/**
 * Shared routing logic for both NotificationCard (list) and ForegroundNotificationBanner.
 * Resolves missing IDs via API if necessary before navigating.
 */
export async function navigateFromNotification(
  notification: any,
  router: NextRouter
): Promise<void> {
  try {
    // const text = notification.text?.trim() || notification.body?.trim();

    // Create a mutable copy since we might fetch and attach bookId
    const notif = { ...notification };

    switch (notif.eventType) {
      // 1. Roleplay Result
      case NOTIFICATION_TYPE.ROLEPLAY_RESULT:
        if (notif?.roleplayId && notif?.chapterId) {
          if (!notif?.bookId) {
            const { data } = await getChapter(notif.chapterId);
            notif.bookId = data.bookId;
          }
          void router.push({
            pathname: "/home/roleplay-result",
            query: {
              moduleId: notif.chapterId,
              roleplayId: notif.roleplayId,
              id: notif?.bookId,
            },
          });
        }
        break;

      // 2. Coach Result
      case NOTIFICATION_TYPE.COACH_RESULT:
        if (notif?.chapterId) {
          if (!notif?.bookId) {
            const { data } = await getChapter(notif.chapterId);
            notif.bookId = data.bookId;
          }
          void router.push({
            pathname: "/home/roleplay-result",
            query: {
              moduleId: notif.chapterId,
              roleplayId: notif.actionId || notif.roleplayId,
              id: notif?.bookId,
              aiType: notif?.aiType,
            },
          });
        }
        break;

      // 3. Evaluation Result
      case NOTIFICATION_TYPE.EVALUATION_RESULT:
        if (notif?.actionId) {
          void router.push(
            {
              pathname: `/interview/${notif?.actionId}/result`,
              query: {
                id: notif?.bookId,
                moduleId: notif?.chapterId || notif?.moduleId,
                submitted: "true",
              },
            },
            undefined,
            { shallow: true }
          );
        }
        break;

      // 4. Roleplay Start
      case NOTIFICATION_TYPE.ROLEPLAY_ASSIGNED:
        if (
          notif?.roleplayId &&
          notif?.chapterId &&
          notif?.bookId &&
          notif?.actionId
        ) {
          void router.push({
            pathname: `/home/roleplay`,
            query: {
              roleplayId: notif.roleplayId,
              moduleId: notif.chapterId,
              id: notif.bookId,
              resultId: notif.actionId,
              isNotification: 1,
            },
          });
        } else {
          console.error(
            "Missing required notification properties for Roleplay",
            notif
          );
        }
        break;

      // 5. Evaluation Start
      case NOTIFICATION_TYPE.EVALUATION_EXPIRY_REMINDER:
      case NOTIFICATION_TYPE.EVALUATION_ASSIGNED:
        void router.push({
          pathname: `assignments`,
          query: {
            tab: "evaluation",
            isNotification: 1,
          },
        });
        break;

      // Assessment start
      case NOTIFICATION_TYPE.ASSESSMENT_EXPIRY_REMINDER:
      case NOTIFICATION_TYPE.ASSESSMENT_ASSIGNED:
        void router.push({
          pathname: `assignments`,
          query: {
            tab: "assessment",
            isNotification: 1,
          },
        });
        break;

      case NOTIFICATION_TYPE.FEED_CREATED:
        void router.push({
          pathname: notif.url,
          query: {
            isNotification: 1,
          },
        });
        break;

      case NOTIFICATION_TYPE.SURVEY_ASSIGNED:
        void router.push({
          pathname: `/feedbacks/new`,
          query: {
            feedbackId: notif.feedbackId,
            isNotification: 1,
          },
        });
        break;

      case NOTIFICATION_TYPE.MODULE_PUBLISHED:
      case NOTIFICATION_TYPE.TRAINING_ASSIGNED:
      case NOTIFICATION_TYPE.TRAINING_PUBLISHED:
      case NOTIFICATION_TYPE.ON_BOARDING_TRAINING_ASSIGNED:
      case NOTIFICATION_TYPE.ON_BOARDING_TRAINING_EXPIRED:
        void router.push({
          pathname: `/home/training`,
          query: {
            id: notif.actionId,
            isNotification: 1,
          },
        });
        break;

      default:
        console.error("Unknown notification type or no route defined", notif);
    }
  } catch (err) {
    console.error("navigateFromNotification error:", err);
  }
}
